module.exports = __webpack_public_path__ + "static/media/Logo-de.697a8e1f.svg";